import { createAction } from "redux-actions";
import { TRANSFER_REQUEST } from "../constants";
import { feathersCreateData } from "../services";

// export const transferRequest = createAction(TRANSFER_REQUEST, (data) => serverTransferRequest(urlTransferCodes, data)())
export const transferRequest = createAction(TRANSFER_REQUEST, (data) => feathersCreateData('transfer-codes', data)())